import React, { useEffect, useState, Suspense } from 'react';

const LazyConsent = React.lazy(() => import('./ConsentBanner'));

const DeferredConsentBanner: React.FC = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const start = () => setTimeout(() => setShow(true), 1200);
    if ('requestIdleCallback' in window) {
      (window as any).requestIdleCallback(start, { timeout: 2000 });
    } else if (document.readyState === 'complete') {
      start();
    } else {
      (window as Window).addEventListener('load', start, { once: true });
      return () => (window as Window).removeEventListener('load', start);
    }
  }, []);
  if (!show) return null;
  return (
    <Suspense fallback={null}>
      <LazyConsent />
    </Suspense>
  );
};

export default DeferredConsentBanner;

